var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnsattsok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86 97",
    style: {
      enableBackground: "new 0 0 86 97"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C9AA0;}\n\t.st1{fill:#FCF1E6;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:24;stroke-miterlimit:10;}\n\t.st4{fill:#F9F9F9;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:11;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_2123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.22,54.66c0,0-0.01,0-0.01,0c-15.02-0.04-27.27-12.29-27.32-27.31C15.89,12.26,28.15,0,43.22,0s27.33,12.26,27.33,27.33 S58.29,54.66,43.22,54.66z M43.22,7.63c-10.86,0-19.7,8.84-19.7,19.7c0.03,10.83,8.88,19.67,19.71,19.7 c10.86,0,19.69-8.84,19.69-19.7C62.92,16.47,54.08,7.63,43.22,7.63z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_2124_1_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.34,96.54h-7.63c0-19.58-15.93-35.5-35.5-35.5s-35.5,15.93-35.5,35.5H0.08c0-23.78,19.35-43.13,43.13-43.13 S86.34,72.75,86.34,96.54z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnsattsok);
export default __webpack_public_path__ + "static/media/ansattsok.2e081eab89b0893069fe550489f41671.svg";
export { ForwardRef as ReactComponent };